import { createContext } from 'react';

export interface IAlertContext {
    showAlert: (message: string) => void;
}

export const AlertContext = createContext<IAlertContext>({
    showAlert: () => {},
});
